export default class BaseApi {
  async get(url) {
    try {

      const headers = {
        'X-WP-Nonce': scriptsData.nonce
      }

      if (scriptsData.siteLanguage) {
        headers['X-Language'] = scriptsData.siteLanguage;
      }

      const response = await fetch(url, { method: 'GET', headers });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      const totalPages = response.headers.get('X-WP-TotalPages') || 0;

      return { data, totalPages };

    } catch (error) {
      // console.error('Fetching error:', error);
      return { data: [], totalPages: 0 };
    }
  }
}